import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IConfReportes } from '@/modules/Reportes/interfaces'
import type { IListaSqlResultadoPaginado } from '@/modules/Configuracion/interfaces'
export class ReporteService extends BaseService<IConfReportes> {
  constructor() {
    super({
      baseUrl: 'report/reports/'
    })
  }
  async execute(
    data: unknown
  ): Promise<AxiosResponse<IResponseApi<unknown[]>>> {
    return this.http.post<IResponseApi<unknown[]>>(`/run-query`, data)
  }
  async executePaginated(
    data: unknown
  ): Promise<AxiosResponse<IResponseApi<IListaSqlResultadoPaginado>>> {
    return this.http.post<IResponseApi<IListaSqlResultadoPaginado>>(`/run-query-paginated`, data)
  }
  async resultQuery(
    consulta: string
  ): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http.post<IResponseApi<unknown>>('/result-query', { consulta })
  }
  async executePreview(
    data: unknown
  ): Promise<AxiosResponse<IResponseApi<unknown[]>>> {
    return this.http.post<IResponseApi<unknown[]>>(`/preview-query`, data)
  }
}
